<template>
  <div class="flex flex-col p-2 w-full" style="min-width: 60vw">
    <el-table :data="list" row-key="id" :show-header="false" style="width: 100%">
      <el-table-column label="Cover" key="cover">
        <template slot-scope="scope">
          <div class="static inline-block text-center container-action">
            <img :src="scope.row.cover" style="width: 100px;height: 100px;object-fit: cover" />
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="column in titles" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
      </el-table-column>
      <el-table-column label="Actions" align="right" min-width="100px">
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip :label="!scope.row.added?'Add':'Remove'" :position="'is-left'">
              <button v-if="!scope.row.added" @click="addPlaylistTo(scope.row,true)" class="p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon :icon="['fa', 'plus']" /> Add
              </button>
              <button v-if="scope.row.added" @click="addPlaylistTo(scope.row,false)" class="p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon  :icon="['fa', 'check']" /> Remove
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '../../mixins/helpers.mixins';

export default {
  name: 'SearchPlaylist',
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    takenPlaylist: {
      type: Array | [],
      default: () => [],
    },
  },
  data() {
    return {
      addPlaylist: [],
      displayingItem: 20,
      list: [],
      total: 0,
      titles: [{
        prop: 'title',
        label: 'Title',
      },
      {
        prop: 'total_song',
        label: 'Songs',
      },
      {
        prop: 'total_play',
        label: 'Plays',
      },],
      filter: '',
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
    ...mapGetters('PlaylistModule', ['listPlaylist']),
  },
  watch: {
    toggleReset: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.resetState();
          await this.search();
        }
      },
    },
    listPlaylist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listPlaylist.data != null && this.listPlaylist.data != undefined) {
          this.list = this.listPlaylist.data.map(play => ({ ...play, total_song: `${play.total_song} Songs`, total_play: `${play.total_play} Plays`, added: this.isExist(play.id) }));
        }
      },
    },
  },
  async mounted() {
    this.total = 0;
    this.list = [];
  },
  methods: {
    ...mapActions('PlaylistModule', ['requestGetListPlaylist']),
    resetState() {
      this.addPlaylist = [...this.takenPlaylist];
      this.list = [];
      this.total = 0;
      this.filter = '';
    },
    async searchPlaylist() {
      // eslint-disable-next-line max-len
      await this.requestGetListPlaylist();
    },
    async search() {
      await this.requestGetListPlaylist();
    },
    isExist(id) {
      return this.addPlaylist.findIndex(song => song.id === id) !== -1;
    },
    addPlaylistTo(row, status) {
      row.added = status;
      if (status) {
        const newRow = { ...row };
        this.addPlaylist.push(newRow);
      } else {
        this.$emit('on-remove-playlist', row.id);
        const index = this.addPlaylist.findIndex(song => song.id === row.id);
        this.addPlaylist.splice(index, 1);
      }
    },
    submit() {
      this.$emit('on-submit-playlist', this.addPlaylist);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/SearchPlaylist.vue